import { Header, InlineBlockDiv } from "@atlassiansox/microscopekit";
import Tooltip from "@atlaskit/tooltip";
import QuestionCircleIcon from "@atlaskit/icon/glyph/question-circle";
import React from "react";
export var LabelWithHelperText = function (props) {
    return props.insideHeader ? (React.createElement(InlineBlockDiv, null,
        React.createElement(Header, null,
            React.createElement(Tooltip, { content: props.helperText },
                React.createElement(InlineBlockDiv, null,
                    props.label,
                    React.createElement(QuestionCircleIcon, { label: "helper", size: "small" })))))) : (React.createElement(InlineBlockDiv, null,
        React.createElement(Tooltip, { content: props.helperText },
            React.createElement(InlineBlockDiv, null,
                props.label,
                React.createElement(QuestionCircleIcon, { label: "helper", size: "small" })))));
};
